import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';

import ReduxToastr from 'react-redux-toastr';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from './store';
import ConfirmModal from './components/utils/ConfirmModal';
import ConfirmDeleteModel from './components/utils/ConfirmDeleteModel';
import { ThemeProvider } from './context/ThemeContext';

const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<Provider store={store}>
		<ThemeProvider>
		<ConfirmModal />
		<ConfirmDeleteModel />
		<ReduxToastr
			timeOut={4000}
			newestOnTop={true}
			preventDuplicates
			position='bottom-right'
			getState={(state) => state.toastr} // This is the default
			transitionIn='fadeIn'
			transitionOut='fadeOut'
			progressBar
			closeOnToastrClick
		/>

		<App />
		</ThemeProvider>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
